
class SystemUtils {
    static async getDeviceInfo() {
        let deviceInfo = {};
        deviceInfo.navigator = {};
        deviceInfo.navigator.connection = {};
        deviceInfo.batteryManager = {};

        if (navigator) {
            deviceInfo.navigator.userAgent = navigator.userAgent;
            deviceInfo.onLine = navigator.onLine;
            deviceInfo.navigator.language = navigator.language;
            deviceInfo.navigator.cookieEnabled = navigator.cookieEnabled;
            deviceInfo.navigator.deviceMemory = navigator.deviceMemory;
            deviceInfo.navigator.bluetooth = navigator.bluetooth;
            await putBatteryInformationTo(deviceInfo);
        }

        if (navigator && navigator.connection) {
            putConnectionInformationTo(deviceInfo);
        }
        async function putBatteryInformationTo(deviceInfo) {

            const batteryManager = (await navigator.getBattery()); // returning batteryManager as promise promise

            deviceInfo.batteryManager.level = batteryManager.level;
            deviceInfo.batteryManager.charging = batteryManager.charging;
            deviceInfo.batteryManager.chargingTime = batteryManager.chargingTime;
            deviceInfo.batteryManager.dischargingTime = batteryManager.dischargingTime
        }
        function putConnectionInformationTo(deviceInfo) {
            deviceInfo.navigator.connection.effectiveType = navigator.connection.effectiveType;
            deviceInfo.navigator.connection.rtt = navigator.connection.rtt;
            deviceInfo.navigator.connection.downlink = navigator.connection.downlink;
            deviceInfo.navigator.connection.saveData = navigator.connection.saveData
            deviceInfo.navigator.connection.downlinkMax = navigator.connection.downlinkMax
        }
        return deviceInfo;
    }
}

// const System = new SystemUtils();
//
export default SystemUtils